// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 MindTenet LLC
// This file is part of Undef Engine.

// Chat types matching backend models
// Using const objects for compatibility with erasableSyntaxOnly

export const MessageType = {
  PUBLIC: 'public',
  TEAM: 'team',
  SYSTEM: 'system',
  WHISPER: 'whisper',
} as const;
export type MessageType = (typeof MessageType)[keyof typeof MessageType];

export const DeliveryStatus = {
  SENDING: 'sending',
  DELIVERED: 'delivered',
  FAILED: 'failed',
} as const;
export type DeliveryStatus = (typeof DeliveryStatus)[keyof typeof DeliveryStatus];

export const ChatClientActionEnum = {
  CHAT_SEND_MESSAGE: 'CHAT_SEND_MESSAGE',
  CHAT_TYPING_START: 'CHAT_TYPING_START',
  CHAT_TYPING_STOP: 'CHAT_TYPING_STOP',
  CHAT_ADD_REACTION: 'CHAT_ADD_REACTION',
  CHAT_REMOVE_REACTION: 'CHAT_REMOVE_REACTION',
  CHAT_GET_HISTORY: 'CHAT_GET_HISTORY',
} as const;
export type ChatClientActionEnum = (typeof ChatClientActionEnum)[keyof typeof ChatClientActionEnum];

export const ChatServerActionEnum = {
  CHAT_NEW_MESSAGE: 'CHAT_NEW_MESSAGE',
  CHAT_TYPING_UPDATE: 'CHAT_TYPING_UPDATE',
  CHAT_REACTION_ADDED: 'CHAT_REACTION_ADDED',
  CHAT_REACTION_REMOVED: 'CHAT_REACTION_REMOVED',
  CHAT_HISTORY_RESPONSE: 'CHAT_HISTORY_RESPONSE',
} as const;
export type ChatServerActionEnum = (typeof ChatServerActionEnum)[keyof typeof ChatServerActionEnum];

export interface ChatMessage {
  message_id: string;
  session_id: string;
  player_id: string;
  player_name: string;
  content: string;
  message_type: MessageType;
  timestamp: string;
  edited: boolean;
  reactions: Record<string, string[]>;
  // Client-side delivery status tracking (optional, not from server)
  delivery_status?: DeliveryStatus;
  // For whisper messages
  recipient_id?: string | null;
  recipient_name?: string | null;
}

export interface ChatTypingUpdate {
  typing_players: string[];
}

export interface ChatReactionUpdate {
  message_id: string;
  reactions: Record<string, string[]>;
}

export interface ChatHistoryResponse {
  messages: ChatMessage[];
  count: number;
}

export interface SendMessagePayload {
  content: string;
  message_type?: MessageType;
}

export interface ReactionPayload {
  message_id: string;
  emoji: string;
}

export interface GetHistoryPayload {
  limit?: number;
}
